import cogoToast from 'cogo-toast';
import api from './apiURL';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// Get All Categories Data
export const getAllProductsByCategoryID = createAsyncThunk(
  'shop/getAllProductsByCategoryID',
  async ( categoryId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;
    const headers = {
      'Content-type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${localStorage.getItem("token")}`,
    };
    const pageUrl = (page) =>
      api + '/api/v1/products-by-category/' + categoryId + '?limit=100&page=' + page;

    try {
      const res = await fetch(pageUrl(1), { method: 'GET', headers });
      const data = await res.json();

      // The API pages its results - load the remaining pages too, so the
      // category shows every product instead of only the first page.
      const totalPages = data?.pagination?.totalPages || 1;
      if (data.success !== false && Array.isArray(data.products) && totalPages > 1) {
        const pages = await Promise.all(
          Array.from({ length: totalPages - 1 }, (_, i) =>
            fetch(pageUrl(i + 2), { method: 'GET', headers }).then((pageRes) => pageRes.json())
          )
        );
        const seen = new Set(data.products.map((product) => product.id));
        pages.forEach((page) => (page.products || []).forEach((product) => {
          if (!seen.has(product.id)) {
            seen.add(product.id);
            data.products.push(product);
          }
        }));
      }
      return data;

    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Get Product Data By ID 
export const getProductByID = createAsyncThunk(
  'shop/getProductByID',
  async ( productId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/products/'+ productId + '', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Get Product Data By ID with VariantId
export const getProductByIDWithVariants = createAsyncThunk(
  'shop/getProductByIDWithVariants',
  async ( productId, queryString, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/products/'+ productId + '/variation' + queryString + '', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Get Category Variations By ID 
export const getCategoryVariationsByID = createAsyncThunk(
  'shop/getCategoryVariationsByID',
  async ( categoryId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/products-filters/'+ categoryId + '', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);


// Search products (server-side regex search, tenant scoped)
export const searchProducts = createAsyncThunk(
  'shop/searchProducts',
  async (query, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await fetch(
        api + '/api/v1/products/search?q=' + encodeURIComponent(query) + '&page=1',
        {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

const ShopSlice = createSlice({
    name: "shop",
    initialState: {
      error: null,
      products: [],
      childCategories: [],
      categoryInfo: null,
      categoryLoading: false,
      currentCategoryId: null,
      productById: {},
      productVariationId: "",
      categoryVariationsList: [],
      searchResults: [],
      searchLoading: false,
    },
    reducers: {},
    extraReducers: {
      [searchProducts.pending]: (state) => {
        state.searchLoading = true;
      },
      [searchProducts.fulfilled]: (state, action) => {
        state.searchLoading = false;
        state.searchResults = action.payload?.products || [];
      },
      [searchProducts.rejected]: (state) => {
        state.searchLoading = false;
        state.searchResults = [];
      },
      // Get Categories
      [getAllProductsByCategoryID.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
        state.categoryLoading = true;
        state.currentCategoryId = action.meta.arg;
      },
      [getAllProductsByCategoryID.fulfilled]: (state, action) => {
        // Ignore a slower response for a category the shopper already left.
        if (action.meta.arg !== state.currentCategoryId) return;
        state.categoryLoading = false;

        if (action.payload.success === false){
          state.products = [];
          state.childCategories = [];
          state.categoryInfo = null;
          // cogoToast.error("Categories Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.products = action.payload.products ?? [];
          state.childCategories = action.payload.childCategories ?? [];
          state.categoryInfo = { categoryId: action.payload.categoryId, name: action.payload.name };

          // cogoToast.success("Categories Success", {position: "bottom-left"});
        }

      },
      [getAllProductsByCategoryID.rejected]: (state, action) => {
          if (action.meta.arg !== state.currentCategoryId) return;
          state.categoryLoading = false;
          state.products = [];
          state.error = action.payload;
          // cogoToast.error("Categories Failed", {position: "bottom-left"});
      },

      // Get Product By ID
      [getProductByID.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getProductByID.fulfilled]: (state, action) => {

        if (action.payload.success === false){
          
          // cogoToast.error("Categories Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.productById = action.payload;
          // cogoToast.success("Categories Success", {position: "bottom-left"});
        }
          
      },
      [getProductByID.rejected]: (state, action) => {
          state.error = action.payload;
          // cogoToast.error("Categories Failed", {position: "bottom-left"});
      },

      // Get Product By ID with Variants
      [getProductByIDWithVariants.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getProductByIDWithVariants.fulfilled]: (state, action) => {

        if (action.payload.success === false){
          
          // cogoToast.error("Categories Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.productVariationId = action.payload.variationId;
          
          // cogoToast.success("Categories Success", {position: "bottom-left"});
        }
          
      },
      [getProductByIDWithVariants.rejected]: (state, action) => {
          state.error = action.payload;
          
          // cogoToast.error("Categories Failed", {position: "bottom-left"});
      },


      // Get Category Variants By ID
      [getCategoryVariationsByID.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getCategoryVariationsByID.fulfilled]: (state, action) => {

        if (action.payload.success === false){
          
          // cogoToast.error("Categories Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.categoryVariationsList = action.payload;
          
          // cogoToast.success("Categories Success", {position: "bottom-left"});
        }
          
      },
      [getCategoryVariationsByID.rejected]: (state, action) => {
          state.error = action.payload;
          
          // cogoToast.error("Categories Failed", {position: "bottom-left"});
      },
    }
});


export default ShopSlice.reducer;
